/**
 * @generated SignedSource<<a9b6b0be9ef2fd2766433c6030741c05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilterTaxonomy_filter",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowSelectingMultipleTaxonomies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterElementsOutOnInitialize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MapTaxonomy",
      "kind": "LinkedField",
      "name": "mapTaxonomies",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasChildren",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MapTaxonomy",
          "kind": "LinkedField",
          "name": "children",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapFilterTaxonomyFilterWithChildren_mapTaxonomy"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapFilterTaxonomyFilterWithoutChildren_mapTaxonomy"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MapFilterTaxonomy",
  "abstractKey": null
};
})();

node.hash = "67bbd6eb5f22d368482b3797a7ed4e22";

module.exports = node;
